import { RootState, ScreenNames } from '@client/types'

export const getScreens = (state: RootState) => state.screens
export const getScreen = (state: RootState, screenName: ScreenNames) =>
  state.screens.mainScreens[screenName]
export const getSpecial = (state: RootState, slug: string) =>
  state.screens.specials[slug]
